<template>
    <v-container
            fluid
    >
        <template v-if="showDetails()">
            <div class="subheading grey--text text--darken-1 pl-4 pb-2">Details</div>
            <v-layout
                row
            >
                <v-flex
                    xs12
                >
                    <v-card>
                        <v-container fluid grid-list-lg>
                            <v-layout row>
                                <v-flex xs1>
                                    <v-card-media
                                        height="125px"
                                        contain
                                        :src="provider.Logo"
                                    ></v-card-media>
                                </v-flex>
                                <v-flex xs11>
                                    <div class="headline">{{ provider.Name }}</div>

                                    <v-layout row>
                                        <v-flex xs2 class="label grey--text text--darken-1">Link type</v-flex>
                                        <v-flex xs10>{{ provider.LinkType }}</v-flex>
                                    </v-layout>

                                    <v-layout row>
                                        <v-flex xs2 class="label grey--text text--darken-1">Authorize url</v-flex>
                                        <v-flex xs10>{{ provider.AuthorizeUrl }}</v-flex>
                                    </v-layout>

                                    <v-layout row>
                                        <v-flex xs2 class="label grey--text text--darken-1">Client ID</v-flex>
                                        <v-flex xs10>{{ provider.ClientId }}</v-flex>
                                    </v-layout>

                                    <v-layout row>
                                        <v-flex xs2 class="label grey--text text--darken-1">Token url</v-flex>
                                        <v-flex xs10>{{ provider.TokenUrl }}</v-flex>
                                    </v-layout>

                                    <v-layout row>
                                        <v-flex xs2 class="label grey--text text--darken-1">Profile format</v-flex>
                                        <v-flex xs10>{{ provider.ProfileFormat }}</v-flex>
                                    </v-layout>

                                    <v-layout row>
                                        <v-flex xs2 class="label grey--text text--darken-1">scopes</v-flex>
                                        <div
                                            v-if="provider.Scopes"
                                        >
                                            <v-chip
                                                v-for="scope in provider.Scopes.split(' ')"
                                                :key="scope"
                                            >
                                                {{ scope }}
                                            </v-chip>
                                        </div>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>

            <div class="subheading grey--text text--darken-1 pl-4 pt-4 pb-2">Schemas</div>

            <div
                v-if="schemas.length === 0"
                class="text-xs-center pt-2 pb-2 grey--text text--darken-1"
            >
                No schemas
            </div>

            <template v-else>
                <v-layout
                    row
                >
                    <v-flex
                        xs12
                    >
                        <v-card>
                            <v-list
                                one-line
                            >
                                <v-list-group
                                    v-for="(item, index) in schemas"
                                    :key="item.Version"
                                    @click=""
                                >
                                    <v-list-tile
                                        avatar
                                        ripple
                                        slot="item"
                                        @click="schema(item.Version)"
                                    >
                                        <v-list-tile-avatar>
                                            <v-icon>fa-code-fork</v-icon>
                                        </v-list-tile-avatar>

                                        <v-list-tile-content>
                                            <v-list-tile-title class="bold">{{ item.Version }}</v-list-tile-title>
                                        </v-list-tile-content>

                                        <v-list-tile-action>
                                            <v-list-tile-action-text
                                            >
                                                <v-btn
                                                    icon
                                                    ripple
                                                    class="grey--text text--lighten-2"
                                                    :href="item.DocUrl"
                                                    target="_blank"
                                                >
                                                    <v-icon>fa-book</v-icon>
                                                </v-btn>
                                            </v-list-tile-action-text>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list-group>
                            </v-list>
                        </v-card>
                    </v-flex>
                </v-layout>
            </template>
        </template>

        <template v-if="showEndpoints()">
            <div class="subheading grey--text text--darken-1 pl-4 pb-2">Endpoints</div>

            <v-flex
                xs12
            >
                <v-card>
                    <v-list
                        two-line
                    >
                        <v-list-group
                            v-for="(item, index) in endpoints"
                            :key="item.Code"
                            @click=""
                        >
                            <v-list-tile
                                avatar
                                ripple
                                slot="item"
                                @click="endpoint(item.Code)"
                            >
                                <v-list-tile-avatar>
                                    <v-icon>fa-code-fork</v-icon>
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                    <v-list-tile-title class="bold">{{ item.Code }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.ShortDescription }}</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action v-if="hasDoc(item)">
                                    <v-list-tile-action-text
                                    >
                                        <v-btn
                                            icon
                                            ripple
                                            class="grey--text text--lighten-2"
                                            :href="item.DocUrl"
                                            target="_blank"
                                        >
                                            <v-icon>fa-book</v-icon>
                                        </v-btn>
                                    </v-list-tile-action-text>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list-group>
                    </v-list>
                </v-card>
            </v-flex>
        </template>

        <template v-if="showMappings()">
            <div class="subheading grey--text text--darken-1 pl-4 pb-2">Mappings</div>

            <v-flex
                xs12
            >
                <v-card>
                    <v-list
                        two-line
                    >
                        <v-list-group
                            v-for="(item, index) in mappings"
                            :key="item.ResponsePath"
                            @click=""
                        >
                            <v-list-tile
                                avatar
                                ripple
                                slot="item"
                            >
                                <v-list-tile-avatar>
                                    <v-icon>fa-code-fork</v-icon>
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                    <v-list-tile-title class="bold">{{ item.ResponsePath }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.Description }}</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                    <v-list-tile-action-text
                                    >
                                        {{ item.PropertyId }}
                                    </v-list-tile-action-text>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list-group>
                    </v-list>
                </v-card>
            </v-flex>
        </template>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';
    import { pathToBreadcrumbs } from '../utils/breadcrumbs';

    export default {
        name: 'provider',
        props: {
            profilePath: String,
        },
        data() {
            return {
                title: 'Profile Provider Schemas',
            };
        },
        computed: {
            ...mapState('profileProviders', {
                provider: state => state.provider,
                schemas: state => state.schemas,
                endpoints: state => state.endpoints,
                mappings: state => state.mappings,
                params: state => state.params,
            }),
        },
        methods: {
            showDetails() {
                return this.params.schema === undefined;
            },
            showEndpoints() {
                return this.params.schema !== undefined && this.params.endpoint === undefined;
            },
            showMappings() {
                return this.params.schema !== undefined && this.params.endpoint !== undefined;
            },
            schema(code) {
                if (this.params.schema !== code) {
                    this.$router.push({ path: `/providers/${this.params.profileProvider}/${code}` });
                }
            },
            endpoint(code) {
                if (this.params.endpoint !== code) {
                    this.$router.push({ path: `/providers/${this.params.profileProvider}/${this.params.schema}/${code}` });
                }
            },
            mapping(code) {
                if (this.params.mapping !== code) {
                    const provider = this.params.profileProvider;
                    const schema = this.params.schema;
                    const mapping = this.params.mapping;
                    this.$router.push({ path: `/providers/${provider}/${schema}/${mapping}/${code}` });
                }
            },
            profilePathChanged(newPath) {
                const breadcrumbs = pathToBreadcrumbs({
                    id: 'profileProviders',
                    text: 'Profile Providers',
                    to: '/providers',
                },
                newPath);
                const profileProvider = breadcrumbs[1].id;
                const schema = breadcrumbs[2] ? breadcrumbs[2].id : undefined;
                const endpoint = breadcrumbs[3] ? breadcrumbs[3].id : undefined;
                const mapping = breadcrumbs[4] ? breadcrumbs[4].id : undefined;

                this.$store.commit('nav/BREADCRUMBS', breadcrumbs);
                this.$store.dispatch('profileProviders/LOAD', {
                    profileProvider: profileProvider,
                    schema: schema,
                    endpoint: endpoint,
                    mapping: mapping,
                });
            },
            hasDoc(item) {
                return item.DocUrl && (item.DocUrl.length > 0);
            },
        },
        watch: {
            profilePath(newPath) {
                this.profilePathChanged(newPath);
            },
        },
        created() {
            this.profilePathChanged(this.profilePath);
        },
    };
</script>

<style lang="stylus" scoped>
    .v-container
        min-height: 0

    .flex
        .label
            &:after
                content: ":"
</style>



// WEBPACK FOOTER //
// ProfileProvider.vue?1a0d580e